<script setup>
import { BaseTableRow, BaseTableCell } from 'dashboard/components-next/table';
import RowMenu from 'dashboard/components-next/polaris/cards/RowMenu.vue';
import { useSettingsRowMenu } from '../../components/useSettingsRowMenu';

const props = defineProps({
  app: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['edit', 'delete']);
const { rowMenuItems, rowMenuLabel } = useSettingsRowMenu();
const onAction = action => {
  if (action === 'edit') emit('edit', props.app);
  else emit('delete', props.app);
};
</script>

<!-- Phase 9.9: the kit's table row — name, the URL (wraps), the ⋮ menu (R2-9-4). -->
<template>
  <BaseTableRow :item="app">
    <BaseTableCell>{{ app.title }}</BaseTableCell>
    <BaseTableCell wrap class="break-all">
      {{ app.content[0].url }}
    </BaseTableCell>
    <BaseTableCell actions>
      <RowMenu
        :label="rowMenuLabel(app.title)"
        :items="rowMenuItems()"
        @action="onAction"
      />
    </BaseTableCell>
  </BaseTableRow>
</template>
